import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApartmentThreeComponent } from './apartment-three.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';
import { Angular2ImageGalleryModule } from 'angular2-image-gallery/app/angular2imagegallery.module';
import { ImgHeaderModule } from '../../img-header/img-header.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    Angular2ImageGalleryModule,
    ImgHeaderModule
  ],
  declarations: [
    ApartmentThreeComponent
  ],
  exports: [
    ApartmentThreeComponent
  ]
})
export class ApartmentThreeModule { }



// WEBPACK FOOTER //
// ./src/app/pages/apartment-three/apartment-three.module.ts